import { useTranslation } from "react-i18next";
import { Dialog } from "./Dialog";

export interface ShortcutGroup {
  title: string;
  items: ReadonlyArray<{ keys: ReadonlyArray<string>; label: string }>;
}

/** The "?" overlay: groups of key/description rows. Labels arrive translated from the screen that owns them. */
export function ShortcutsOverlay({
  open,
  onClose,
  groups,
}: {
  open: boolean;
  onClose: () => void;
  groups: ReadonlyArray<ShortcutGroup>;
}) {
  const { t } = useTranslation("components");
  return (
    <Dialog open={open} onClose={onClose} title={t("shortcuts.title")} width="sm">
      <div className="flex flex-col gap-4" data-component="ShortcutsOverlay">
        {groups.map((group) => (
          <section key={group.title} className="flex flex-col gap-1.5">
            <h3 className="label-mono">{group.title}</h3>
            <dl className="m-0 grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5">
              {group.items.map((item) => (
                <div key={item.keys.join("+")} className="contents">
                  <dt className="flex gap-1">
                    {item.keys.map((key) => (
                      <kbd
                        key={key}
                        className="inline-flex h-5 min-w-5 items-center justify-center rounded-sm border border-line bg-sunken px-1.5 font-mono text-label text-ink"
                      >
                        {key}
                      </kbd>
                    ))}
                  </dt>
                  <dd className="m-0 text-ui text-ink-2">{item.label}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
        <p className="text-data text-ink-3">{t("shortcuts.hint")}</p>
      </div>
    </Dialog>
  );
}
